/// <reference path="appbase.ts" />

namespace TerminalApp {
    let appId = "app_order_info";

    export class App_Order_Info extends AppBase {
        bound = false;

        // Btns
        button_search_item = document.getElementById("order_info_search_order");
        button_search_ean = document.getElementById("order_info_search_tote");

        orderInfo_btn_address = document.querySelector(".order-info-btn-address");
        orderInfo_btn_delivery = document.querySelector(".order-info-btn-delivery");
        orderInfo_btn_droppoint = document.querySelector(".order-info-btn-droppoint");

        // Scanner Logo
        orderInfo_scan_logo = document.getElementById("orderInfo-scan-logo") as HTMLElement;

        // Scanned Tote
        orderInfo_showTote_overall_container = document.querySelector(".orderInfo-showTote-overall-container") as HTMLElement;
        orderInfo_showTote_container = document.querySelector(".orderInfo-showTote-container") as HTMLElement;
        orderInfo_ErrorMsg_text = document.querySelector(".orderInfo-scan-emptyScannedTote") as HTMLElement;

        // Order
        orderInfo_shopName_input = document.getElementById("orderInfo-shopName") as HTMLElement;
        orderInfo_referenceNo_input = document.getElementById("orderInfo-ReferenceNo") as HTMLElement;
        orderInfo_orderNo_input = document.getElementById("orderInfo-OrderNo") as HTMLElement;
        orderInfo_status_input = document.getElementById("orderInfo-status") as HTMLElement;

        order_info_orderLines_holder = document.querySelector(".order-info-orderLines") as HTMLElement;

        orderInfo_customerNote_overall_container = document.querySelector(".order-info-customerNote-overall-container") as HTMLElement;
        orderInfo_customerNote_textarea = document.querySelector(".order-info-customerNote-textarea") as HTMLTextAreaElement;

        orderInfo_orderNote_overall_container = document.querySelector(".order-info-orderNote-overall-container") as HTMLElement;
        orderInfo_orderNote_click_container = document.querySelector(".order-info-textarea-btn") as HTMLElement;
        orderInfo_orderNote_textarea = document.querySelector(".order-info-orderNote-textarea") as HTMLTextAreaElement;

        orderInfo_deliveryMethod = document.getElementById("orderInfo-deliveryMethod") as HTMLElement;
        orderInfo_droppoint = document.getElementById("orderInfo-droppoint") as HTMLElement;

        order_info_container: HTMLElement;
        order_info_overall_container: HTMLElement;

        addressForm: AddressFormAssistant;
        delivery_method_picker = new PickAssistant<SP.DeliveryMethod>(SP.Localize("sentance_select_delivery_method"));
        droppoint_picker = new PickAssistant<SP.DropPointInfo>(SP.Localize("sentance_select_droppoint"));
        orderAssistant: OrderSearcherAssistant;
        orderNoteForm: OrderNoteForm;

        currentOrder: SP.OrderInfo;
        currentCustomer: SP.CustomerInfo;

        isDropPoint = false;

        constructor() {
            super(appId);

            this.addressForm = new AddressFormAssistant();
            this.orderAssistant = new OrderSearcherAssistant();
            this.orderNoteForm = new OrderNoteForm();
            this.container.appendChild(this.addressForm.container);
            this.container.appendChild(this.delivery_method_picker.container);
            this.container.appendChild(this.droppoint_picker.container);
            this.container.appendChild(this.orderAssistant.container);
            this.container.appendChild(this.orderNoteForm.container);

            // Search Order Btn
            this.button_search_item.addEventListener("click", () => {
                SP.Sounds.Click.play();
                this.orderAssistant.open((order, customer) => {
                    this.showOrderDetails(order, customer);
                });
            });

            // Search Tote Btn
            this.button_search_ean.addEventListener("click", () => {
                SP.Sounds.Click.play();
                toteAssistant.open(false, (toteId) => {
                    this.scanTote(toteId.toString());
                });
            });

            // Edit address btn
            this.orderInfo_btn_address.addEventListener("click", () => {
                SP.Sounds.Click.play();
                this.addressForm.open(this.currentOrder);
            })

            // Edit delivery btn
            this.orderInfo_btn_delivery.addEventListener("click", async () => {
                SP.Sounds.Click.play();
                await this.delivery_method_picker.open(dm => {
                    this.setDeliveryMethod(dm);
                });
            });

            // Edit droppoint btn
            this.orderInfo_btn_droppoint.addEventListener("click", async () => {
                if (!this.isDropPoint) {
                    return;
                }

                SP.Sounds.Click.play();
                this.updateDroppoints();

                await this.droppoint_picker.open(dropPoint => {
                    this.setDroppoint(dropPoint);
                })
            });

            // Edit order note btn
            this.orderInfo_orderNote_click_container.addEventListener("click", () => {
                SP.Sounds.Click.play();
                this.orderNoteForm.open(this.currentOrder, (note) => {
                    this.setOrderNote(note);
                });
            });

            this.order_info_overall_container = document.querySelector(".order-info-overall-container");
            this.order_info_container = this.order_info_overall_container.querySelector(".order-info-container");
        }

        async onOpen() {
            this.reset();

            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("t", this.scanTote, this); // t står for tote, stregkoden starter med t_
            }

            var orderid = SP.getHash("orderId");
            if (orderid) {
                this.showOrderDetailsById(parseInt(orderid));
            }
        }

        async onClose() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("t", this.scanTote);
            }

            this.reset();
        }


        reset() {
            this.currentOrder = null;
            this.currentCustomer = null;


            this.orderInfo_scan_logo.style.display = "block";
            this.orderInfo_ErrorMsg_text.style.display = "none";

            this.orderInfo_showTote_overall_container.style.display = "none";
            this.order_info_container.style.display = "none";

            this.orderInfo_customerNote_overall_container.style.display = "none";

            this.resetInput();

            this.orderInfo_showTote_container.innerHTML = "";
            this.order_info_orderLines_holder.innerHTML = "";

            this.isDropPoint = false;
        }

        resetInput() {
            this.orderInfo_btn_delivery.setAttribute("data-deliverymethodid", "");

            this.orderInfo_shopName_input.innerText = "";
            this.orderInfo_referenceNo_input.innerText = "";
            this.orderInfo_orderNo_input.innerText = "";
            this.orderInfo_status_input.innerHTML = "";

            this.orderInfo_deliveryMethod.innerText = "";
            this.orderInfo_droppoint.innerText = "";

            this.orderInfo_customerNote_textarea.value = "";
            this.orderInfo_orderNote_textarea.value = "";
        }

        async scanTote(toteId: string) {
            this.reset();

            var toteInfo = await SP.Data.Tote.getToteInfo(toteId);

            if (toteInfo == null || toteInfo.picks.length == 0) {
                SP.Sounds.Error.play();
                SP.Sounds.Vibrate;
                this.orderInfo_ErrorMsg_text.style.display = "block";
                return;
            }

            if (toteInfo.shipmentId) {
                var shipment = await SP.Data.Shipment.getShipmentInfo(toteInfo.shipmentId);

                this.showOrderDetailsById(shipment.order.orderId);
            }
        }

        async showOrderDetailsById(orderId: number) {
            if (!orderId) {
                return;
            }

            StartLoading();
            try {
                let order = await SP.Data.Order.getOrderInfo(orderId);

                const customer = await SP.Data.Customer.getCustomerInfo(order.customerId.toString(), true);
                this.showOrderDetails(order, customer);
            }
            finally {
                StopLoading();
            }
        }

        async showOrderDetails(order: SP.OrderInfo, customer: SP.CustomerInfo) {
            if (this.currentOrder != order) {
                this.reset();
                ignoreHashChange = true;
                SP.setHash("orderId", order.orderId.toString());
                await SP.sleep(1);
                ignoreHashChange = false;

                this.currentOrder = order;
                this.currentCustomer = customer;

                // Outputs all totes the order is in as html elements
                await this.addTotes(order.orderId);

                // Reference
                this.orderInfo_shopName_input.innerText = customer.customerName.toString();
                this.orderInfo_referenceNo_input.innerText = order.referenceNo.toString();
                this.orderInfo_orderNo_input.innerText = order.orderNo.toString();
                this.setState(order.state.toString());

                // Delivery Method
                this.isDropPoint = order.deliveryMethodInfo.isDropPoint;
                this.orderInfo_btn_delivery.setAttribute("data-deliverymethodid", order.deliveryMethodInfo.id);

                this.orderInfo_deliveryMethod.innerText = order.deliveryMethodInfo.name.toString();

                if (order.deliveryMethodInfo.isDropPoint) {
                    this.orderInfo_droppoint.innerText = order.droppointId.toString();
                }
                else {
                    this.orderInfo_droppoint.innerText = SP.Localize("sentance_not_applicable");
                }

                if (order.customerComment.length != 0) {
                    this.orderInfo_customerNote_overall_container.style.display = "block";
                    this.orderInfo_customerNote_textarea.value = order.customerComment;
                }

                if (order.note.length != 0) {
                    this.orderInfo_orderNote_textarea.value = order.note;
                }

                // OrderLines
                this.addOrderLines(order);

                // Hide scan logo and text
                this.orderInfo_scan_logo.style.display = "none";

                // Show info container
                this.order_info_container.style.display = "block";
            }

            this.updateDeliveryMethods();
        }


        setState(state: string) {
            if (state == SP.OrderState.ReadyForPacking.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-green far fa-check-circle" title="${SP.Localize("sentance_ready_for_packing")}"></i> ${SP.Localize("sentance_ready_for_packing")}
                `;
            }
            else if (state == SP.OrderState.Packing.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-green fas fa-shipping-fast" title="${SP.Localize("sentance_being_packed")}"></i> ${SP.Localize("sentance_being_packed")}
                `;
            }
            else if (state == SP.OrderState.Packed.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-green fas fa-check-circle" title="${SP.Localize("word_packed")}"></i> ${SP.Localize("word_packed")}
                `;
            }
            else if (state == SP.OrderState.ItemsMissing.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-orange fas fa-minus-circle" title="${SP.Localize("sentance_missing_items")}"></i> ${SP.Localize("sentance_missing_items")}
                `;
            }
            else if (state == SP.OrderState.Error.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-red fas fa-times-circle" title="${SP.Localize("word_error")}"></i> ${SP.Localize("word_error")}
                `;
            }
            else if (state == SP.OrderState.Cancelled.toString()) {
                this.orderInfo_status_input.innerHTML = `
                    <i class="text-gray fas fa-times-circle" title="${SP.Localize("word_canceled")}"></i> ${SP.Localize("word_canceled")}
                `;
            }
        }

        setOrderNote(note: string) {
            this.orderInfo_orderNote_textarea.value = note;
        }

        async setDeliveryMethod(deliveryMethod: SP.DeliveryMethod) {
            SP.Sounds.Click.play();

            this.orderInfo_btn_delivery.setAttribute("data-deliverymethodid", deliveryMethod.id);
            this.orderInfo_deliveryMethod.innerText = deliveryMethod.name;

            this.isDropPoint = deliveryMethod.isDropPoint;

            if (deliveryMethod.isDropPoint) {
                this.orderInfo_droppoint.innerText = SP.Localize("sentance_select_droppoint");
            }
            else {
                this.orderInfo_droppoint.innerText = SP.Localize("sentance_not_applicable");
            }

            var postData = {
                id: this.currentOrder.orderId,
                CustomerId: this.currentOrder.customerId,
                deliveryMethod: deliveryMethod.methodKeys.split(",")[0]
            };

/*            StartLoading();*/

            try {
                let result = await SP.post<any>("/api/v1/order/update", postData);
            } catch {
/*                StopLoading();*/
                SP.alertX("Error trying to save deliverymethod");
            }
            finally {
/*                StopLoading();*/
            }
        }

        async setDroppoint(droppoint: SP.DropPointInfo) {
            console.log(droppoint);
            this.orderInfo_droppoint.innerText = droppoint.id;

            let postData = {
                Id: this.currentOrder.orderId,
                CustomerId: this.currentOrder.customerId,
                DroppointId: droppoint.id,
            }

            //StartLoading();

            try {
                let result = await SP.post<any>("/api/v1/order/update", postData);
            } catch {
                //StopLoading();
                SP.alertX("Error trying to save droppoint");
            }
            finally {
                //StopLoading();
            }
        }

        addOrderLine(o: SP.OrderLineInfo) {
            let description = o.itemInfo?.description;
            if (description == null || description == "") {
                description = o.description ?? "";
            }

            var elm = document.createElement("div");
            elm.innerHTML = `
                    <div class="setting_group ${(o.bundleParent != null ? "bundle_child" : "")}">
                        <div class="setting">
                            <div class="order-info-orderLine-overall-container">
                            
                            <i class="fa-duotone fa-turn-down-right order-info-orderLine-icon" style="display: none;"></i>

                                <div class="order-info-orderLine-image-container">
                                    <img class="order-info-orderLine-image" src="${o.imageUrl}" />
                                </div>
                                
                                <div class="order-info-orderLine-info-container">
                                    <div class="order-info-orderLine-info-nameAndSku-container">
                                        <p class="order-info-orderLine-info-nameAndSku-name">${description}</p>
                                        <span class="order-info-orderLine-info-nameAndSku-sku">${o.itemInfo?.sku ?? ""}</span>
                                    </div>

                                    <div class="order-info-orderLine-info-quantity-container">
                                        <p class="order-info-orderLine-quantity">${o.qty}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                `;

            var img = elm.querySelector(".order-info-orderLine-image") as HTMLElement;
            img.style.pointerEvents = "all";

            if (o.itemInfo) {
                img.addEventListener("click", () => {
                    SP.Sounds.Click.play();
                    itemShortcutAssistant.open_with_info(o.itemInfo);
                });
            }

            this.order_info_orderLines_holder.appendChild(elm);
        }

        // Output all order lines
        addOrderLines(order: SP.OrderInfo) {

            order.items.forEach(o => {
                if (o.bundleParent != null) return;

                this.addOrderLine(o);
                order.items.forEach(c => {
                    if (c.bundleParent == o.id)
                        this.addOrderLine(c);
                });

            });
        }

        updateDeliveryMethods() {
            this.delivery_method_picker.clear();
            for (let key in this.currentCustomer.deliveryMethods) {
                let m = this.currentCustomer.deliveryMethods[key];
                if (m.isReturn) continue;
                if (m.orderSources.length && !m.orderSources.includes(this.currentOrder.orderSource)) continue;

                var localPrices = m.prices[this.currentOrder.recipient.country.toUpperCase()];
                let available = localPrices != null;

                (m as any).available = available;
                this.delivery_method_picker.addItem(m, available, m.name, "");
            }
        }

        async updateDroppoints() {
            this.droppoint_picker.clear();

            try {
                let order = this.currentOrder;
                let currentDeliveryMethodId = this.orderInfo_btn_delivery.getAttribute("data-deliverymethodid");

                var droppoints = await SP.Data.DeliveryMethod.getDroppoints(currentDeliveryMethodId, order.customerId, order.recipient.country, order.recipient.zipcode, order.recipient.city, order.recipient.street1);
                if (!droppoints || droppoints == null) {
                    await SP.alertX("No droppoints found");
                }

                for (let key in droppoints) {
                    let droppoint = droppoints[key];

                    let dpName = `${droppoint.name} (${droppoint.distance})`;

                    this.droppoint_picker.addItem(droppoint, true, dpName, "");
                }
            } catch {
                SP.alertX("Error");
            }
        }

        // Output all tote as html elements
        async addTotes(orderId: number) {
            var totes = await SP.Data.Tote.getOrderToteInfos(orderId.toString());

            if (totes.length == 0) {
                return;
            }

            // Show scanned totes
            this.orderInfo_showTote_overall_container.style.display = "block";

            totes.forEach(t => {
                var piBox = new PlacementInfoBox(t.totePlacementData, true, null);

                let toteHtml = `
                    <div class="setting_group">
                        <div class="setting">
                            
                        </div>
                    </div>
                `;

                // Append as last child
                this.orderInfo_showTote_container.insertAdjacentHTML("beforeend", toteHtml);
                this.orderInfo_showTote_container.lastElementChild.querySelector(".setting").appendChild(piBox.container);
            });
        }

    }


    RegisterApp(appId, App_Order_Info);
}